"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileListLink = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var files_1 = require("utils/constants/files");
var urls_1 = require("utils/constants/urls");
var FileListLink = function (_a) {
    var file = _a.file, link = _a.link, isMobile = _a.isMobile, target = _a.target, filename = _a.filename;
    var isExternalFileType = files_1.MOBILE_EXTERNAL_VIEWER_FILETYPES.includes(file.type);
    var isExternalLink = urls_1.externalUrlPatterns.some(function (url) { return link.includes(url); });
    return (React.createElement(React.Fragment, null, isMobile && isExternalFileType && isExternalLink ? (React.createElement("a", { href: link, target: target, rel: "noopener noreferrer" }, file.name)) : (React.createElement(react_router_dom_1.Link, { to: link, target: target }, filename || file.name))));
};
exports.FileListLink = FileListLink;
